import type { DashboardCampaign } from "@adpilot/shared";
import type { TFunction } from "i18next";

export type PolicyFilter = "managed_group" | "inherited" | "override" | "disabled" | "excluded";
export type RunFilter = "attention" | "completed" | "analyzing" | "never";

export function policyLabel(t: TFunction, value: DashboardCampaign["aiPolicyState"]) {
  return value === "managed_group"
    ? t("list.policyLabel.managedGroup")
    : value === "inherited"
      ? t("list.policyLabel.inherited")
      : value === "override"
        ? t("list.policyLabel.override")
        : value === "excluded"
          ? t("list.policyLabel.excluded")
          : t("list.policyLabel.disabled");
}

export function runGroup(campaign: DashboardCampaign): RunFilter {
  const status = campaign.latestAiRun?.status;
  if (!status) return "never";
  if (status === "running") return "analyzing";
  if (status === "suspended" || status === "failed") return "attention";
  return "completed";
}

export function runLabel(t: TFunction, campaign: DashboardCampaign) {
  const run = campaign.latestAiRun;
  if (!run) return t("list.runLabel.noRun");
  if (run.status === "running") return t("list.runLabel.analyzing");
  if (run.status === "suspended") return t("list.runLabel.decisionNeeded");
  if (run.status === "failed") return t("list.runLabel.needsAttention");
  if (run.autoExecuted > 0) return t("list.runLabel.executed");
  if (run.skipped > 0) return t("list.runLabel.skippedSafely");
  return t("list.runLabel.observed");
}
